<script>
    import { createEventDispatcher, onMount } from "svelte";

    import Select from "svelte-select/Select.svelte";

    import CreateSurgeonModal from "../CreateSurgeonModal.svelte";

    import { NotificationModal } from "../../../../Components/Common/index.svelte";

    import {
        user,
        loggedInDoctorDetail,
        accountDoctors,
        preOpQuestionnaires,
        postOpSurveys,
    } from "../../../../stores";

    import { apiMethods } from "../../../../Services/index.svelte";

    import {
        getHHMM,
        getTitle,
        getYYYYMMDD,
        isObjectEmpty,
        showInfo,
    } from "../../../../Utils/utilFunctions.svelte";

    import {
        CardLayout,
        Loader,
        DateInput,
    } from "../../../../Components/Common/index.svelte";

    import {
        addErrorInput,
        removeErrorInput,
    } from "../../helpers/encounterUtils.svelte";

    import { encounterBillingType } from "../../../../Utils/utilEnums.svelte";
    import debounce from "lodash/debounce";
    import { FallBackEncounterDurationMins } from "../../../../Utils/utilConstants.svelte";
    import CustomTooltip from "../../../../Components/Common/CustomTooltip.svelte";

    export let selectedSurgeon = {},
        patientEncounterDetails = {},
        selectedHospital = {},
        createSurgeonFilters,
        typeOfBill = Number(0),
        isFromCreate = false,
        isEncounterHasActiveInvoice = false,
        disableInputScenario_TWO = false,
        UNLOCK_ALL_INPUTS = false,
        overrideValidation = false,
        insuranceDetailsRef;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (!$accountDoctors.length && !hasAccountDoctorsFetched)
        loadAccountDoctors();

    $: _syncSurgeonOptions($accountDoctors, suggestedAccountDoctors);

    $: if (selectedSurgeon?.details && !selectedSurgeon.details.displayLabel)
        selectedSurgeon.details.displayLabel = getOptionLabelForSurgeon(
            selectedSurgeon.details,
        );

    $: requiresShowHospitalChangeConfirmModal =
        _getRequiresShowHospitalChangeConfirmModal(patientEncounterDetails);

    let isCreateNewSurgeonModalOpen = false;

    let hasAccountDoctorsFetched = false,
        isLoadingAccountDoctors = false,
        hasSuggestedAccountDoctorsFetched = false,
        isLoadingSuggestedAccountDoctors = false,
        suggestedAccountDoctors = [];

    let hasSuggestedHospitalsFetched = false,
        isLoadingSuggestedHospitals = false,
        suggestedHospitals = [];

    let surgeonOptions = [],
        hospitalOptions = [];

    let errInputs = [];

    let dischargeDateSelectorRefresh;

    let backupHospital = {},
        newHospital = {},
        isHospitalChangeConfirmModalOpen = false;

    let isReloadingSurgeon = false,
        isReloadingHospital = false;
    
    let showDischargeDateField = false;

    onMount(() => {
      
    });

    export const checkProcedureDetailsValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    const dispatch = createEventDispatcher();

    const loadAccountDoctors = async (replaceSelectedSurgeon = true) => {
        isLoadingAccountDoctors = true;

        const doctorId = isFlowEnableSearchDoctor
            ? $loggedInDoctorDetail.id
            : $user.id;

        if (doctorId)
            await apiMethods.getMethod
                .getAccountDoctors(0, 999999, {
                    "filter[doctorId]": doctorId,
                })
                .then((res) => {
                    if (res.results) {
                        $accountDoctors = [...res.results];

                        if (replaceSelectedSurgeon) {
                            selectedSurgeon.details = $accountDoctors.find(
                                (s) => s.id == selectedSurgeon?.details?.id,
                            );
                            if (selectedSurgeon)
                                selectedSurgeon.matchingId = `${selectedSurgeon.id}${selectedSurgeon.state}`;
                        }
                    }
                });

        hasAccountDoctorsFetched = true;

        isLoadingAccountDoctors = false;
    };

    export const reloadSurgeon = async () => {
        isReloadingSurgeon = true;

        await loadAccountDoctors();

        await loadSuggestedAccountDoctors(true);

        clearCurrentSurgeon();

        isReloadingSurgeon = false;
    };

    export const reloadHospital = async () => {
        isReloadingHospital = true;

        // clearCurrentHospital();

        await onFocusHospitalSelector(true);

        isReloadingHospital = false;
    };

    const loadSuggestedAccountDoctors = async (forceReload = false) => {
        if (
            !forceReload &&
            (suggestedAccountDoctors.length ||
                hasSuggestedAccountDoctorsFetched)
        )
            return;

        const doctorID = $loggedInDoctorDetail.id;

        if (!doctorID) return;

        isLoadingSuggestedAccountDoctors = true;

        await apiMethods.getMethod.getSuggestedSurgeon(doctorID).then((res) => {
            if (res.results) suggestedAccountDoctors = [...res.results];
        });

        //filter surgeons and take only once by unique id
        suggestedAccountDoctors = [
            ...new Map(suggestedAccountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        if (suggestedAccountDoctors.length > 5)
            suggestedAccountDoctors = suggestedAccountDoctors.slice(0, 5);

        hasSuggestedAccountDoctorsFetched = true;

        isLoadingSuggestedAccountDoctors = false;
    };

    const loadSuggestedHospitals = async (forceReload = false) => {
        if (
            !forceReload &&
            (suggestedHospitals.length ||
                hasSuggestedHospitalsFetched ||
                isLoadingSuggestedHospitals)
        )
            return;

        const doctorID = $loggedInDoctorDetail.id;

        if (!doctorID) return;

        isLoadingSuggestedHospitals = true;

        await apiMethods.getMethod
            .getSuggestedHospital(doctorID)
            .then((res) => {
                if (res.results) {
                    suggestedHospitals = [...res.results];

                    const suggestedOptions = [];

                    suggestedHospitals.map((hospital) => {
                        suggestedOptions.push({
                            ...hospital,
                            groupName: "Suggested Hospitals",
                        });
                    });

                    hospitalOptions = [...suggestedOptions];
                }
            });

        hasSuggestedHospitalsFetched = true;

        isLoadingSuggestedHospitals = false;
    };

    const loadHospitals = async (searchText) => {
        const res = searchText
            ? await apiMethods.getMethod.getHospitals(0, 999999, {
                  search: searchText,
              })
            : await Promise.resolve([]);

        return _handleSearchHospitals(
            res.results?.length > 0 ? res.results : [],
        );
    };

    const groupBy = (option) => option.groupName;

    const getOptionLabelForSurgeon = ({
        firstName,
        lastName,
        title,
        speciality,
        state,
    }) =>
        `${getTitle(title)} ${firstName} ${lastName} (${speciality})`;

    const clearCurrentSurgeon = () => {
        selectedSurgeon = {};

        errInputs = removeErrorInput(
            "surgeonSelect",
            errInputs,
            "Surgeon/Referrer",
        );

        restSurgeonContainerStyle();
    };

    const onFocusSurgeonSelector = () => {
        loadSuggestedAccountDoctors();

        restSurgeonContainerStyle();
    };

    const restSurgeonContainerStyle = () => {
        const surgeonContainer = document.getElementById("surgeonContainer");
        surgeonContainer.style.outline = "";
    };

    const clearCurrentHospital = () => {
        selectedHospital.details = null;

        const hospitalContainer = document.getElementById("hospitalContainer");
        const hospitalSelect = document.getElementById("hospitalSelect");

        hospitalContainer.style.outline = "";
        hospitalSelect.placeholder = "Hospital";

        errInputs = removeErrorInput("hospitalSelect", errInputs, "Hospital");

        resetHospitalContainerStyle();

        loadHospitals();

        requiresShowHospitalChangeConfirmModal &&
            _openConfirmHospitalChangeModal();
    };

    const handleHospitalChange = () => {
        if (isFromCreate) {
            dispatch("onHospitalChange", selectedHospital.details);
            insuranceDetailsRef && insuranceDetailsRef._syncPipInsuranceData();
        } else 
            requiresShowHospitalChangeConfirmModal &&
                _openConfirmHospitalChangeModal();
    };

    const onFocusHospitalSelector = async (forceReload = false) => {
        resetHospitalContainerStyle();

        await loadSuggestedHospitals(forceReload);
    };

    const confirmHospitalChange = () => {
        selectedHospital.details = newHospital;
        backupHospital = newHospital;
        dispatch("onHospitalChange", selectedHospital.details);

        _closeConfirmHospitalChangeModal();

        insuranceDetailsRef && insuranceDetailsRef._syncPipInsuranceData();
    };

    const discardHospitalChange = () => {
        selectedHospital.details = isObjectEmpty(backupHospital)
            ? null
            : { ...backupHospital };

        selectedHospital.outsideHospital = false; //on hospital change, outside hospital is definetly false
        _closeConfirmHospitalChangeModal();
    };

    const resetHospitalContainerStyle = () => {
        const hospitalContainer = document.getElementById("hospitalContainer");
        hospitalContainer.style.outline = "";
    };

    const handleSelectOutsideHospital = () => {
        if (selectedHospital.details) clearCurrentHospital();
        else resetHospitalContainerStyle();
    };

    const openCreateNewSurgeonModal = () =>
        (isCreateNewSurgeonModalOpen = true);

    const closeCreateNewSurgeonModal = () =>
        (isCreateNewSurgeonModalOpen = false);

    // HELPER FUNCTIONS
    const _updateInvalidFieldsStyle = () => {
        if (!selectedSurgeon.details && !overrideValidation) {
            errInputs = addErrorInput(
                "surgeonSelect",
                errInputs,
                "Surgeon/Referrer",
            );

            const surgeonContainer =
                document.getElementById("surgeonContainer");
            surgeonContainer.style.outline = "red solid 2px";
            surgeonContainer.style.borderRadius = "5px";
        } else {
            errInputs = removeErrorInput(
                "surgeonSelect",
                errInputs,
                "Surgeon/Referrer",
            );
            restSurgeonContainerStyle();
        }

        if (
            (!selectedHospital || !selectedHospital.details) && !selectedHospital.outsideHospital &&
            !overrideValidation
        ) {
            errInputs = addErrorInput("hospitalSelect", errInputs, "Hospital");

            const hospitalContainer =
                document.getElementById("hospitalContainer");
            hospitalContainer.style.outline = "red solid 2px";
            hospitalContainer.style.borderRadius = "5px";
        }

        if (!patientEncounterDetails.scheduledDate)
            errInputs = addErrorInput("scheduledDateField", errInputs);
        else errInputs = removeErrorInput("scheduledDateField", errInputs);
    };

    const _syncSurgeonOptions = (
        accountDoctors = [],
        suggestedSurgeons = [],
    ) => {
        surgeonOptions = [];

        let uniqueAccountDoctors = [
            ...new Map(accountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        if (!suggestedSurgeons)
            uniqueAccountDoctors.map((doctor) => {
                surgeonOptions.push({
                    ...doctor,
                    displayLabel: getOptionLabelForSurgeon(doctor),
                    matchingId: `${doctor.id}${doctor.state}`,
                });
            });
        else { 
            const suggestedSurgeonUniqueIds = [];
            const len = Math.min(suggestedSurgeons.length, 5);

            for (let i = 0; i < len; i++) {
                const surgeon = suggestedSurgeons[i];
                
                surgeonOptions.push({
                    ...surgeon,
                    groupName: "Suggested surgeons",
                    displayLabel: getOptionLabelForSurgeon(surgeon),
                    matchingId: `${surgeon.id}${surgeon.state}`,
                });

                suggestedSurgeonUniqueIds.push(surgeon.providerUniqueId);
                
            }

            uniqueAccountDoctors.map((surgeon) => {
                if (
                    !suggestedSurgeonUniqueIds.includes(
                        surgeon.providerUniqueId.toString(),
                    )
                )
                    surgeonOptions.push({
                        ...surgeon,
                        groupName: "Other Surgeons",
                        displayLabel: getOptionLabelForSurgeon(surgeon),
                        matchingId: `${surgeon.id}${surgeon.state}`,
                    });
            });
        }
    };

    const _handleSearchHospitals = (res = []) => {
        hospitalOptions = [];

        if (!res.length && !suggestedHospitals.length) return [];

        const suggestedOptions = [];

        if (res.length) {
            hospitalOptions = [...res];
            return [...res];
        }

        if (!suggestedHospitals.length) return [];

        suggestedHospitals.map((hospital) => {
            suggestedOptions.push({
                ...hospital,
                groupName: "Suggested Hospitals",
            });
        });

        hospitalOptions = [...suggestedOptions];

        return [...suggestedOptions];
    };

    const clearDischargeDate = () => {
        if (!patientEncounterDetails.dischargeDate) {
            patientEncounterDetails.dischargeTime = null;
        }
    };

    const compareAndFixDischargeDate = debounce(() => {
        if (
            !patientEncounterDetails.scheduledDate ||
            !patientEncounterDetails.scheduledTime
        )
            return;
        if (
            !patientEncounterDetails.dischargeDate ||
            !patientEncounterDetails.dischargeTime
        )
            return;

        const scheduleDateTime = new Date(
            `${patientEncounterDetails.scheduledDate}T${patientEncounterDetails.scheduledTime}`,
        );
        const dischargeDateTime = new Date(
            `${patientEncounterDetails.dischargeDate}T${patientEncounterDetails.dischargeTime}`,
        );

        if (scheduleDateTime > dischargeDateTime) {
            const newDischargeDT = new Date(
                scheduleDateTime.setTime(
                    scheduleDateTime.getTime() +
                        FallBackEncounterDurationMins * 60 * 1000,
                ),
            );
            patientEncounterDetails.dischargeTime = getHHMM(newDischargeDT);
            patientEncounterDetails.dischargeDate = getYYYYMMDD(newDischargeDT);
            setTimeout(() => {
                if(dischargeDateSelectorRefresh)
                    dischargeDateSelectorRefresh();
            }, 50);
            showInfo(
                "Discharge date has been set to " +
                    FallBackEncounterDurationMins +
                    " minutes later than scheduled date.",
            );
        }
    }, 300);

    const _getRequiresShowHospitalChangeConfirmModal = (encounter = {}) => {
        if (!encounter || isObjectEmpty(encounter) || !encounter.id) return false;

        const { billingStatus, estimates, invoices } = encounter;

        return (
            billingStatus < 3 &&
            (!estimates?.length || !estimates.some((e) => e.status != 9)) &&
            (!invoices?.length || !invoices.some((i) => i.status != 9))
        );
    };

    const _openConfirmHospitalChangeModal = () => {
        if (!backupHospital || isObjectEmpty(backupHospital))
            backupHospital = patientEncounterDetails.hospital ?? {};

        newHospital = selectedHospital.details
            ? { ...selectedHospital.details }
            : null;

        isHospitalChangeConfirmModalOpen = true;
    };

    const _closeConfirmHospitalChangeModal = () => {
        isHospitalChangeConfirmModalOpen = false;
        newHospital = {};
    };
</script>

<CardLayout title="Procedure Details" enableCollapse={false}>
    <div class="flex-1 p-4 gap-y-4 grid gap-x-0 xl:grid-cols-2 grid-cols-1">
        <div class="flex flex-col flex-1 justify-start gap-y-4 col-span-1 xl:pr-3 responsive-divider" >
            <div class="flex w-full items-center">
                <p class="title">Encounter Type *:</p>
                <select
                    class="select flex-1 select-bordered select-sm"
                    disabled={!UNLOCK_ALL_INPUTS && disableInputScenario_TWO}
                    bind:value={patientEncounterDetails.typeOfBill}
                    on:change={() => dispatch("encounterTypeChange")}
                >
                    {#each encounterBillingType as billingType}
                        <option value={billingType.id}>
                            {billingType.type}
                        </option>
                    {/each}
                </select>
            </div>

            <div class="flex w-full items-center">
                <p class="title">Procedure name:</p>
                <input
                    type="text"
                    id="procedureNameField"
                    placeholder="Procedure name"
                    class="input flex-1 input-sm input-bordered"
                    autocomplete="off"
                    bind:value={patientEncounterDetails.procedureName}
                />
            </div>

            <div class="flex flex-row flex-1 gap-y-2 w-full">
                <div class="flex flex-1 items-center">
                    <p class="title">Surgeon / Referrer *:</p> 

                    {#if isLoadingAccountDoctors}
                        <div class="flex gap-x-2">
                            <p>Loading Surgeon/Referrer</p>
                            <Loader />
                        </div>
                    {:else}
                        <div class="w-remaining flex flex-row gap-x-2 items-center">
                            <div class="flex-1" id="surgeonContainer">
                                <Select
                                    bind:value={selectedSurgeon.details}
                                    id="surgeonSelect"
                                    class="flex flex-1 max-h-[35px] rounded-full"
                                    items={surgeonOptions}
                                    itemId="matchingId"
                                    label="displayLabel"
                                    {groupBy}
                                    on:clear={clearCurrentSurgeon}
                                    on:focus={onFocusSurgeonSelector}
                                    noOptionsMessage="No surgeon/referrer found"
                                    placeholder="Surgeon/Referrer"
                                    disabled={isReloadingSurgeon ||
                                        (!UNLOCK_ALL_INPUTS &&
                                            disableInputScenario_TWO)}
                                    --placeholder-color="#9CA3AF"
                                    --height="32px"
                                    --value-container-padding="0"
                                    --padding="0 0 0 12px"
                                    --font-size="14px"
                                />
                            </div>
                           
                            {#if UNLOCK_ALL_INPUTS || !disableInputScenario_TWO}
                                <CustomTooltip
                                    contentClass="bg-[#fff] border-none"
                                    contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
                                >
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                                    <div slot="tooltipTrigger" on:click={openCreateNewSurgeonModal} class="flex text-center items-center w-[20px] h-[20px] rounded-sm cursor-pointer text-white bg-secondary hover:bg-primary">
                                        <i class="fa fa-plus mr-2 text-[14px] mx-auto" style="margin:0 auto;" aria-hidden="true" />
                                    </div>

                                    Add new surgeon/referrer
                                </CustomTooltip>
                                
                            {/if}

                        </div>
                    {/if}
                </div>
            </div>
        </div>

        <div class="flex flex-col flex-1 gap-y-4 col-span-1 justify-start xl:pl-3" >
            <div class="flex w-full items-center">
                <p class="title">Procedure date *:</p>
                <div class="grid-cols-3 gap-3 grid grid-flow-row-dense flex-1">
                    <div class="col-span-2">
                        <DateInput
                            bind:value={patientEncounterDetails.scheduledDate}
                            placeholder="Encounter Date"
                            id="scheduledDateField"
                            wrapperClass="input input-sm px-0 input-bordered w-full"
                            wrapperClassFocus="inputFocus"
                            isDisable={!UNLOCK_ALL_INPUTS &&
                                disableInputScenario_TWO}
                            on:change={compareAndFixDischargeDate}
                        />
                    </div>
                    <input
                        bind:value={patientEncounterDetails.scheduledTime}
                        type="time"
                        class="input flex-1 input-sm input-bordered col-span-1"
                        id="scheduledTimeField"
                        on:input={compareAndFixDischargeDate}
                        disabled={!UNLOCK_ALL_INPUTS &&
                            disableInputScenario_TWO}
                    />
                </div>
                 <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div class="cursor-pointer underline text-sm flex items-center pl-4" on:click={() => showDischargeDateField = !showDischargeDateField }>
                    {#if showDischargeDateField}
                        Hide discharge
                    {:else}
                        Set discharge
                    {/if}
                </div>
            </div>

            {#if showDischargeDateField}
                <div class="flex w-full items-center">
                    <p class="title">Discharge date:</p>
                    <div class="grid-cols-3 gap-3 grid grid-flow-row-dense flex-1">
                        <div class="col-span-2">
                            <DateInput
                                bind:value={patientEncounterDetails.dischargeDate}
                                minDate={patientEncounterDetails.scheduledDate}
                                placeholder="Discharge Date"
                                id="dischargeDateField"
                                wrapperClass="input input-sm px-0 input-bordered w-full"
                                wrapperClassFocus="inputFocus"
                                showClearButton
                                on:valueCleared={clearDischargeDate}
                                isDisable={!UNLOCK_ALL_INPUTS &&
                                    disableInputScenario_TWO}
                                bind:refreshValue={dischargeDateSelectorRefresh}
                            />
                        </div>
                        <input
                            type="time"
                            class="input flex-1 input-sm input-bordered"
                            bind:value={patientEncounterDetails.dischargeTime}
                            id="dischargeTimeField"
                            disabled={!UNLOCK_ALL_INPUTS &&
                                disableInputScenario_TWO}
                        />
                    </div>
                </div>
            {/if}

            <div class="flex w-full items-center">
                <div class="flex w-full items-center">
                    <p class="title">Hospital *:</p>

                    <div class="w-remaining flex gap-x-2">
                        <div class="flex-1 w-remaining-hospital" id="hospitalContainer">
                            <Select
                                bind:value={selectedHospital.details}
                                id="hospitalSelect"
                                class="flex flex-1 max-h-[35px] rounded-full"
                                loadOptions={loadHospitals}
                                items={hospitalOptions}
                                {groupBy}
                                itemId="id"
                                label="name"
                                on:clear={clearCurrentHospital}
                                on:select={handleHospitalChange}
                                on:focus={onFocusHospitalSelector}
                                noOptionsMessage="No hospital found"
                                placeholder="Hospital"
                                disabled={isReloadingHospital ||
                                    (!UNLOCK_ALL_INPUTS &&
                                        disableInputScenario_TWO) ||
                                    selectedHospital.outsideHospital}
                                --placeholder-color="#9CA3AF"
                                --height="32px"
                                --value-container-padding="0"
                                --padding="0 0 0 12px"
                                --font-size="14px"
                            />
                        </div>
                        <div class="flex items-center gap-x-2 w-[120px]">
                            <input
                                type="checkbox"
                                id="outsideHospitalCheckbox"
                                class="toggle toggle-secondary"
                                autocomplete="off"
                                bind:checked={selectedHospital.outsideHospital}
                                on:change={handleSelectOutsideHospital}
                            />
                            <p class="font-bold text-xs">OUTSIDE HOSPITAL</p>
                        </div>
                    </div>

                    
                </div>
            </div>
        </div>
    </div>
</CardLayout>

<CreateSurgeonModal
    {isCreateNewSurgeonModalOpen}
    reloadSurgeonDetails={() => loadAccountDoctors(false)}
    closeFunc={closeCreateNewSurgeonModal}
    bind:filters={createSurgeonFilters}
    bind:selectedSurgeon={selectedSurgeon.details}
    doctorId={$loggedInDoctorDetail.id}
    existedOptions={surgeonOptions}
/>

<NotificationModal
    title="Hospital Change"
    isModalOpen={isHospitalChangeConfirmModalOpen}
    isReverseBtns
    cancelText="Proceed"
    closeModal={confirmHospitalChange}
    submitText="Cancel"
    confirmAction={discardHospitalChange}
    closeModalFunction={discardHospitalChange}
>
    <div class="flex flex-col gap-y-4 p-">
        <p>
            Changing hospitals will reset all item numbers and billing rule if
            there is currently no quote or invoice.
        </p>

        <p>Do you wish to proceed?</p>
    </div>
</NotificationModal>

<style>
    .title {
        width: 10rem;
    }

    @media (min-width: 1280px) {
        .responsive-divider {
            border-right: 2px solid #eaeaea;
        }
    }

    .responsive-divider {
        border-left: none;
    }

    .w-remaining {
        width: calc(100% - 160px);
    }

    .w-remaining-hospital {
        width: calc(100% - 120px);
    }
</style>
